//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../no/Section.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[0,"AllowSelfIntersection",1,0],[0,"Associative",1,0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[0,"FixAtCurrentTimestamp",1,0],[0,"FrecAtTimeStamp",1,"Features.Feature",0],[0,"HideOriginal",1,1],[0,"InheritDisplayProperties",1,0],[0,"InputCurvesOption",1,0],[0,"JoinOption",1,0],[0,"MakePositionIndependent",1,0],[0,"ParentPart",1,0],[0,"ReverseDirection",1,0],[1,"Section",0,"Section",0],[0,"SourcePartOccurrence",1,"TaggedObject",0],[0,"Tolerance",1,0]],[[[],"CommitCreateOnTheFly",{R_:{feature:"Features.Feature"}},0,0],[["info","xform_exists","xform_origin","xform_orientation","xform_scale"],"GetWaveLinkInformation",{},0,0],[["nSelectedObjects","selectedObjects"],"GetProductInterfaceObjects",{},0,0],[["selectedObjects"],"SetProductInterfaceObjects",{},1,0],[["nSourcePartOccurrences","sourcePartOccurrences"],"GetSourcePartOccurrences",{},0,0],[["sourcePartOccurrences"],"SetSourcePartOccurrences",{},1,0],[["curveTag","calcStatus","parentPartName","objectName","status"],"GetParentInformation",{},2,0]],[]];
SPLM.Features.CompositeCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.CompositeCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.CompositeCurveBuilder.PartType = Object.freeze({
    "WorkPart" : "WorkPart", "OtherPart" : "OtherPart"});

SPLM.Features.CompositeCurveBuilder.JoinMethod = Object.freeze({
    "No" : "No", "Cubic" : "Cubic", "Genernal" : "Genernal", "Quintic" : "Quintic"});

SPLM.Features.CompositeCurveBuilder.InputCurves = Object.freeze({
    "Keep" : "Keep", "Hide" : "Hide", "Delete" : "Delete", "Replace" : "Replace"});

export default SPLM;